// SuggestedPrompt - Formerly legacyConfig.ts
// Provides configuration for the MCAPSHelp Copilot suggested prompts and welcome message

import { getSuggestionsAsJsonString } from './botSuggestionsService';
import { getEnvVarUtils } from '../../../../core/utils/utils';

// Helper function to replace <UserName> placeholder with actual user name
export const replaceUserNamePlaceholder = (message: string, fullName?: string): string => {
  // If full name is provided, use it directly
  if (fullName && fullName.trim()) {
    return message.replace('<UserName>', fullName.trim());
  }
  
  // Default fallback
  return message.replace('<UserName>', 'User');
};

export const getBotWelcomeMessage = (): string => {
  const envVariables = getEnvVarUtils();
  const appName = sessionStorage.getItem('mcapsCopilot_appName');

  // Tile-specific welcome messages from environment variables
  if (appName) {
    const tileKey = appName ? `${appName}_Welcome_Message` : null;
    if (tileKey) {
      const tileMessage = envVariables.find((item) => item.key === tileKey)?.value;
      if (tileMessage) return tileMessage;
    }
  }

  // Default welcome message
  const defaultMessage = envVariables.find(
    (item) => item.key === 'McapsCopilotBotWelcomeMessage'
  )?.value;

  return defaultMessage || 'Hello <UserName>! I\'m your MCAPSHelp Agent, here to assist you with your MCAPS help and support needs. Here are some suggestions to help you get started:';
};

export interface LegacyCopilotConfig {
  botWelcomeMessage?: string;
  botSuggestionMessage?: string; // JSON string array of suggestions
}

// Dynamic function to get latest suggestions from session storage
export const getDynamicSuggestions = (): string => {
  return getSuggestionsAsJsonString('defaultSuggestions');
};

export const SAMPLE_CONFIGURATIONS = {
  LEGACY_MAIN_JSX: {
    get botWelcomeMessage() {
      return getBotWelcomeMessage();
    },
    // Will be populated dynamically by component
    botSuggestionMessage: '[]'
  }
};